import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';
import { ANCHOR } from 'common/consts/common';

import styles from './ArticleNoteSmReduced.module.scss';

@injectIntl
export default class ArticleNoteSmComponent extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    news: PropTypes.object.isRequired
  };

  render() {
    const {
      className,
      news: {
        title,
        photo: { url },
        slug,
        publicationDate
      }
    } = this.props;
    const language = LanguageService.getLang();
    const year = moment(publicationDate).format('YYYY');

    return (
      <div className={`${styles.PressNoteSm} ${className}`}>
        <a href={`${ANCHOR.PRESSROOM[language]}/${year}/${slug}`}>
          <div
            className={styles.ContentImage}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                url
              )})`
            }}
          />
          <div className={styles.ContainerDetails}>
            <div className={styles.ContainerHeaderDetails}>
              <div className={styles.ContainerContactInfo}>
                <span className={styles.ProductNameSpan}>{title}</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/ArticleNoteSmReduced/ArticleNoteSmReduced.js